import * as React from 'react';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import S from './PostcodeModal.styles';
import Button from '@stories/Components/Buttons/Button/Button';
const PostcodeModal = ({ visible, onClose, onSubmit }) => {
    const [searchTerm, setSearchTerm] = React.useState('');
    if (!visible) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Close, { onClick: onClose },
                React.createElement(SvgClose, { "aria-hidden": true }),
                React.createElement("span", null, "Close")),
            React.createElement(S.Heading, null, "Postcode Filter"),
            React.createElement(S.Intro, null, "In order to help us find the landscapers closest to you, please input your postcode:"),
            React.createElement(S.Input, { placeholder: "Postcode", type: "search", value: searchTerm, onChange: (event) => {
                    setSearchTerm(event.target.value);
                } }),
            React.createElement(Button, { themeOption: 'aplGreen', title: "Sort Results", type: "submit", onClick: (e) => {
                    e.preventDefault();
                    onSubmit(searchTerm);
                    setSearchTerm('');
                } }))));
};
export default PostcodeModal;
